export default "__VITE_ASSET__DVUAZTyA__"